<script setup>
import { reactive, watch } from 'vue'
import { GoogleSignIn, MicrosoftSignIn, AuthStateChanged } from '../firebase_files/login';
import { store } from '../store';
import router from '../router';
import WaitForUser from '@/components/WaitForUser.vue';

const state = reactive({
    mode: 'login',
    resultOfLogin:null,
    waitingOnData:false, // when this is true, we show the waiting screen
})

watch(store, (newVal, oldVal) => {
  console.log(`store.user: ${store.user}`)
  console.log(`store.newUser: ${store.newUser}`)
  console.log(`store.userRole: ${store.userRole}`)
  console.log(`store.userObject: ${store.userObject}`)
    if (store.userRole && !store.newUser) {
        router.push('/');
    } else if (store.newUser) {
      console.log('new user')
      router.push({ name: 'edit-account', params: { newAct: 'true' } })
    }
})



async function googleLogin() {
    const resultOfLogin = await GoogleSignIn();
    state.waitingOnData = true;
    state.resultOfLogin = resultOfLogin;
}


async function microsoftLogin() {
    let resultOfLogin = await MicrosoftSignIn();
    state.waitingOnData = true;
    state.resultOfLogin = resultOfLogin;
}

function openLandingPage() {
    const url = 'https://www.verusamb.com/';
    // Open the URL in a new tab
    window.open(url, '_blank');
}

</script>

<template>
    <WaitForUser v-if="state.waitingOnData"/>
    <div v-else>
    <div class="login-top">
        <div class="logo">
            <img src="@/assets/img/verus_logo.png" height="130" class="center">
        </div>
        <div class="button">
            <button @click="openLandingPage()" v-if="state.mode == 'login'">About</button>
        </div>
    </div>


    <div class="login-container" v-if="state.mode == 'login'">

        <div class="image">
            <img src="@/assets/img/logingraphic.png" alt="Login Graphic">
        </div>

        <div class="login-options">

            <div class="ambs">
                AUTOMATED MEDICAL BILLING SYSTEM
            </div>

            <div @click="googleLogin()" class="login-button">
                <div class="img">
                    <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJtMTcuNiA5LjItLjEtMS44SDl2My40aDQuOEMxMy42IDEyIDEzIDEzIDEyIDEzLjZ2Mi4yaDNhOC44IDguOCAwIDAgMCAyLjYtNi42eiIgZmlsbD0iIzQyODVGNCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTkgMThjMi40IDAgNC41LS44IDYtMi4ybC0zLTIuMmE1LjQgNS40IDAgMCAxLTgtMi45SDFWMTNhOSA5IDAgMCAwIDggNXoiIGZpbGw9IiMzNEE4NTMiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik00IDEwLjdhNS40IDUuNCAwIDAgMSAwLTMuNFY1SDFhOSA5IDAgMCAwIDAgOGwzLTIuM3oiIGZpbGw9IiNGQkJDMDUiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDMuNmMxLjMgMCAyLjUuNCAzLjQgMS4zTDE1IDIuM0E5IDkgMCAwIDAgMSA1bDMgMi40YTUuNCA1LjQgMCAwIDEgNS0zLjd6IiBmaWxsPSIjRUE0MzM1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNMCAwaDE4djE4SDB6Ii8+PC9nPjwvc3ZnPg=="
                        alt="G" />
                </div>
                <div class="text">Sign in with Google</div>
            </div>
            <div @click="microsoftLogin()" class="login-button">
                <div class="img">
                    <img src="@/assets/img/Microsoft_logo.svg.png" style="width: 1.125rem; height: 1.125rem">
                </div>
                <div class="text">Sign in with Microsoft</div>
            </div>

        </div>

    </div>
  </div>
</template>
<style scoped lang="scss">
div.login-top {
    display: flex;

    .logo {
        flex: 1;
    }

    .button {
        padding: 1.875rem;
    }
}
div.login-container {
    max-width: 62.5rem;
    margin: auto;
    margin-top: 3.125rem;
    display: flex;

    .image {
        border-radius: 1.24em;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        background-color: #f2f2f2;
        width: 55%;
        text-align: center;

        img {
            width: 90%;
            margin-top: 10%;
        }
    }

    .login-options {
        border-radius: 1.24rem;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        background-color: #6e47a6;
        color: #fff;
        width: 45%;
        text-align: center;
        padding-bottom: 5%;

        .ambs {
            margin: 3.75rem auto 2.5rem auto;
            width: 15.625rem;
            display: inline-block;
            color: #f2f2f2;
            font-family: IBM Plex Mono;
            font-size: 1.375rem;
        }

        .login-button {
            width: 15.313rem;
            padding: 1.8rem 1.2rem;
            margin: 1.25rem auto;
            background-color: #f2f2f2;
            border-radius: 0.313rem;
            color: #757575;
            text-transform: none;
            font-weight: normal;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
            transition: background-color .3s;
            display: flex;

            &:hover {
                background-color: #d4d4d4;
                cursor: pointer;
                color: #6e47a6;
            }

            .img {
                width: 1.563rem;
            }

            .text {
                flex: 1;
            }
        }

    }
}
</style>

